export default "__VITE_ASSET__B0QE29MT__"